import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles/antd.css";
import "./assets/styles/index.css";
import "./assets/styles/antdCustom.css"
import reportWebVitals from "./reportWebVitals";
import { MetaMaskProvider } from "@metamask/sdk-react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MetaMaskProvider
    debug={false}
    sdkOptions={{
      logging: {
        developerMode: false,
      },
      checkInstallationImmediately: false, // This will automatically connect to MetaMask on page load
      dappMetadata: {
        name: 'Admin Re.Monster',
        url: window.location.host,
      },
      i18nOptions: {
        enabled: true,
      },
      i18nInstance: "jp"
    }}
  >
    <App />
  </MetaMaskProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
